import { debounce, type DebouncedFunc } from "lodash";

export const debouncePerKey = <A>(
  fn: (args: A) => void,
  keyOf: (args: A) => string,
  wait: number,
): ((args: A) => void) => {
  const pending = new Map<string, DebouncedFunc<(args: A) => void>>();
  return (args: A) => {
    const key = keyOf(args);
    let debounced = pending.get(key);
    if (!debounced) {
      debounced = debounce(fn, wait);
      pending.set(key, debounced);
    }
    debounced(args);
  };
};
